import ShippingPackage, {
  shippingInitialState,
  ShippingPackageValidationSchema,
} from 'app/features/orders/models/ShippingPackage'
import * as models from 'app/features/orders/models/ShippingPackage'
import {FormikProvider, useFormik} from 'formik'
import {FC, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '_metronic/helpers'
import shippingPackageService from 'app/services/ShippingPackageService'
import {useDispatch} from 'react-redux'
import {showMessage} from 'app/redux/messageSlice'
import {Button} from '_core'
import {TextField, NumberField} from '_core/forms'

import {
  getShippingPackageDetail,
  getShippingPackages,
} from 'app/features/orders/redux/shippingService/shippingPackagesSlice'
import {useParams} from 'react-router-dom'

type Props = {
  showDialog: boolean
  onClose: any
}
const ShippingPackageDialog: FC<Props> = ({showDialog, onClose}) => {
  const dispatch = useDispatch()
  const {id} = useParams<any>()
  const formik = useFormik<ShippingPackage>({
    initialValues: shippingInitialState,
    validationSchema: ShippingPackageValidationSchema,
    onSubmit: handleSubmit,
  })

  useEffect(() => {
    if (id) {
      dispatch(getShippingPackageDetail(id))
    }
  }, [dispatch, id])

  async function handleSubmit(data: models.ShippingPackage) {
    try {
      const values = {...data}
      formik.setSubmitting(true)
      if (id) {
        await update(values)
      } else {
        await create(values)
        dispatch(getShippingPackages({offset: 0, pageSize: 5}))
      }
      formik.resetForm()
      onClose()
    } catch (error) {
      console.error(error)
      dispatch(
        showMessage({text: 'An error occurred while saving shipping package', variant: 'error'})
      )
    } finally {
      formik.setSubmitting(false)
    }
  }

  const create = async (data: models.ShippingPackage) => {
    await shippingPackageService.create(data)
    dispatch(
      showMessage({
        text: 'Shipping Package  created successfully',
        variant: 'success',
      })
    )
  }
  const update = async (data: models.ShippingPackage) => {
    if (id) {
      await shippingPackageService.update(data, id)
      dispatch(
        showMessage({
          message: 'Shipping Package saved successfully',
          variant: 'success',
        })
      )
    }
  }
  return (
    <>
      <Modal
        size='lg'
        id='kt_modal_create_app'
        aria-hidden='true'
        dialogClassName='h-auto w-auto'
        aria-labelledby='contaed-modal-title-vcenter'
        centered
        show={showDialog}
      >
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <div className='mt-5  gap-5'>
              <div className='modal-header d-flex'>
                <h5 className='modal-title'>Add Package</h5>
                <div className='btn btn-icon btn-sm ' data-kt-menu-dismiss='true' onClick={onClose}>
                  <KTSVG
                    className='svg-icon-2 rounded-1 border border-primary svg-icon-primary'
                    path='/media/icons/duotune/arrows/arr061.svg'
                  />
                </div>
              </div>

              <div className='modal-body align-items-center'>
                <div className='mt-5 gap-4 mb-4'>
                  <div className='d-flex flex-column m-5 pb-3'>
                    <label className='form-label fs-6 fw-bold required'>Package Name</label>
                    <TextField id='txtPackageName' name='name' />
                  </div>
                  <div className='mt-5 gap-4 mb-4'>
                    <div className='d-flex flex-column m-5 pb-3'>
                      <div className='d-flex flex-column mt-5 pl-4'></div>
                      <div className='row g-6 g-xl-4'>
                        <div className='col-xl-3'>
                          <label className='form-label fs-6 fw-bold required'>Length</label>
                          <div className='d-flex justify-content-between align-items-center'>
                            <NumberField
                              id='numlength'
                              name='dimension.length'
                              className='form-control'
                              allowNegative={false}
                            />
                          </div>
                        </div>
                        <div className='col-xl-3'>
                          <label className='form-label fs-6 fw-bold required '>Width</label>
                          <div className='d-flex justify-content-between align-items-center'>
                            <NumberField
                              id='numWidth'
                              name='dimension.width'
                              className='form-control'
                              allowNegative={false}
                            />
                          </div>
                        </div>
                        <div className='col-xl-4 mb-5'>
                          <div className='row'>
                            <label className='form-label fs-6 fw-bold required '>Height</label>
                            <div className='d-flex justify-content-between align-items-center'>
                              <NumberField
                                id='numHeight'
                                name='dimension.height'
                                className='form-control'
                                allowNegative={false}
                              />
                              <label className='form-label text-muted mx-8  fs-6 fw-bolder justify-content-end pl-3'>
                                inch
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className='col-xl-4'>
                          <label className='form-label fs-6 fw-bold required'>Weight</label>
                          <div className='d-flex justify-content-between align-items-center'>
                            <NumberField
                              id='numWeight'
                              name='weight.value'
                              className='form-control'
                              allowNegative={false}
                            />
                            <div>
                              <div>
                                <label className='form-label text-muted fs-6 fw-bolder justify-content-end pl-3 mx-8'>
                                  lbs
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='modal-footer'>
                <button
                  id='btnProductClose'
                  className='btn explore-btn-outline btn-sm'
                  onClick={onClose}
                >
                  Cancel
                </button>
                <Button
                  id='btnAdd'
                  type='submit'
                  title='Add'
                  className='btn btn-primary btn-sm ms-5'
                  isSubmitting={formik.isSubmitting}
                  isValid={formik.isValid}
                />
              </div>
            </div>
          </form>
        </FormikProvider>
      </Modal>
    </>
  )
}

export default ShippingPackageDialog
